import classNames from "classnames";

import { Measurement, Size } from "@/api/generatedTypes";

import styles from "./MeasurementsTable.module.scss";

interface MeasurementsTableProps {
  measurements?: Measurement[];
  sizes?: Size[];
  className?: string;
}

const MeasurementsTable = ({
  measurements = [],
  sizes = [],
  className,
}: MeasurementsTableProps) => {
  if (!measurements?.length || !sizes.length) return null;

  const tableHead = ["Замеры (см)"].concat(sizes.map((item) => item.size));

  return (
    <div className={classNames(styles.container, className)}>
      <table className={classNames(styles.table)}>
        <thead>
          <tr>
            {tableHead.map((headCell, index) => (
              <th key={index}>{headCell}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {measurements.map((row, indexRow) => (
            <tr key={indexRow}>
              <td>{row.name}</td>
              {row.values &&
                row.values.map((bodyCell, indexCell) => (
                  <td key={indexCell}>{bodyCell.value}</td>
                ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MeasurementsTable;
